import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react';
import restaurants from '../data/restaurants'
import './Restaurant.css'

class Restaurant extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {

  }
  render() {
    const { id } = this.props.match.params
    const restaurant = _.find(restaurants, (o) => o.id === id )
    return (
      <section id="Restaurant">
        <div className="neighborhood">{ restaurant.neighborhood }</div>
        <h1>{ restaurant.name }</h1>
        <address>
           { restaurant.address}
        </address>
        <div><a href={restaurant.website} target="_blank">Website</a></div>
        <ul class="tags">
        {(restaurant.tags || []).map((tag, i) => {
          return <li>{ tag  }</li>
        })}
        </ul>
      </section>
    )
  }
}

export default Restaurant



// WEBPACK FOOTER //
// ./src/components/Restaurant.js